@let brand = branding();

<div class="flex border-b border-light-700 dark:border-dark-300">
  <div class="menu">
    <div class="menu__left">
      <img [src]="brand.LogoLight" [attr.alt]="brand.Name" [attr.title]="brand.Name" />
    </div>

    <div class="menu__right">
      <div class="max-w-40 overflow-hidden text-ellipsis opacity-70 px-4 py-0">
        <img [src]="brand.ApplicationNameCompanyNameLight" [attr.alt]="brand.Name" [attr.title]="brand.Name" class="max-w-full" />
      </div>
    </div>
  </div>

  <button [class]="actionClasses()" (click)="toggled.emit()">
    <lib-tess-icon [class.rotate-180]="closed()" icon="menu:arrow-backward" size="var(--font-size-xxl)" />
  </button>
</div>
